import {trackPageOpen} from './events/navigation'
import measureWebVitals from './events/performance'

measureWebVitals()
trackPageOpen()

export {trackEvent} from './tracking'
export {initializeStatisticsPlugin, getFusConfig} from './config'
export {scheduleEventsSending} from './scheduler'
